<template>
  <div class="list">
    <div class="justify-align-center list_title">
      <img src="../assets/web/TitleL.png" alt />
      <span>{{title}}</span>
      <img src="../assets/web/TitleR.png" alt />
    </div>
    <div class="myTable">
      <el-table
        :data="data"
        stripe
        :show-header="false"
        @current-change="handleCurrentChange"
        class="pointer"
      >
        <el-table-column :prop="label"></el-table-column>
        <el-table-column width="50" align="center">
          <template>
            <img src="../assets/web/Search.png" alt />
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "data", "label"],
  methods: {
    handleCurrentChange(row) {
      // console.log(row.course);
      this.$emit("current-change", row);
    }
  }
};
</script>

<style lang="scss" scoped>
.list {
  .list_title {
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    margin: 16px 0;
    img {
      margin: 0 15px;
      width: 17px;
      height: 19px;
    }
  }
  .myTable {
    border: 1px solid #d3d7db;
    height: 400px;
    overflow-y: auto;
    // border-right: 1px solid #d3d7db;
  }
}
/deep/.el-table {
  .el-table td,
  .el-table th.is-leaf {
    border: 0px;
  }
  // .el-table td,
  // .el-table th.is-leaf:hover {
  //   border-left: 6px solid rgba(74, 184, 153, 1);
  // }
}
</style>